import React from "react";
import "./style.css";
import { useParams } from "react-router-dom";
import { GetMedicalReqDetails, GetMedicalRequestDetails } from "../../api/endpoints/UsersMedicalRequests";
import { useGet } from "../../api/hooks";
import RequestDetailsContent from "./Components/RequestDetailsContent";
import NoExist from "../../component/NoExist";
import RequestDetailsSkeleton from "./Components/RequestDetailsSkeleton";

export const MedicalRequestDetails = () => {
    const { id } = useParams()
    const { result: requestDetails, isPending } = useGet({ 
        endPoint: GetMedicalReqDetails, 
        depArr: [], 
        allowFetch: !!id, 
        params: [id],
        defaultValue: null
    })

    return (
        <>
            <RequestDetailsSkeleton isRender={isPending} />
            <RequestDetailsContent requestDetails={requestDetails || {}} requestId={id} />
            <NoExist isExist={requestDetails?.orderId && !isPending} />
        </>
    );
}

export default MedicalRequestDetails

